<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row class="justify-content-between">
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>
          <b-col md="6" class="my-1">
            <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm"
              label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredTimesheet"
              :fields="approved_timesheet_fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn"
              @filtered="onFiltered">
              <template #cell(status)="data">
                <b-badge :variant="getStatusVariant(data.item.status)">
                  {{
                    data.item.status.charAt(0).toUpperCase() +
                    data.item.status.toLowerCase().slice(1)
                  }}
                </b-badge>
              </template>
              <template #cell(employee)="data">
                {{ getEmployee(data.item.employeeID) }}
              </template>
              <template #cell(comment)="data">
                {{ data.item.taskDescription }}
              </template>
              <template #cell(totalHours)="data">
                {{ data.item.hoursWorked }}
              </template>
              <template #cell(month)="data">
                {{ formatMonth(data.item.date) }}
              </template>
              <template #cell(submittedOn)="data">
                {{ formatDate(data.item.date) }}
              </template>
              <template #cell(startDate)="data">
                {{ data.item.startDate ? formatDate(data.item.startDate) : '-' }}
              </template>
              <template #cell(endDate)="data">
                {{ data.item.endDate ? formatDate(data.item.endDate) : '-' }}
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item @click="viewTimesheet(data.item)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">View</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal id="modal-view-approved-timesheet" ok-only ok-title="View" centered size="lg"
              title="View Rejected timesheet" :hide-footer="true" ref="modalviewTimesheet">
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <b-form-group label="Date" label-for="date">
                      <b-form-datepicker id="date" placeholder="Date" v-model="timesheetId.date" disabled />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group label="Project" label-for="project">
                      <b-form-select :options="projectOptions" v-model="timesheetId.projectID" disabled />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group label="Employee" label-for="employee">
                      <b-form-select :options="employeeOptions" v-model="timesheetId.employeeID" disabled />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Total Hours" label-for="totalHours">
                      <b-form-input name="totalHours" placeholder="Total Hours" readonly
                        v-model="timesheetId.hoursWorked" />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Description" label-for="description">
                      <b-form-textarea name="description" placeholder="Description" readonly
                        v-model="timesheetId.taskDescription" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </b-col>

          <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
              class="my-0" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormDatepicker,
  BFormTextarea,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BFormDatepicker,
    BFormTextarea,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterOn: [],
      approved_timesheet_fields: [
        { key: "employee", label: "Employee", sortable: true },
        { key: "month", label: "Month", sortable: true },
        { key: "startDate", label: "Start Date", sortable: true },
        { key: "endDate", label: "To Date", sortable: true },
        {
          key: "totalHours",
          label: "Total Hours",
          sortable: true,
        },
        { key: "status", label: "Status", sortable: true },
        { key: "comment", label: "Comment", sortable: true },
        { key: "submittedOn", label: "Submitted On", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      timesheetId: {
        date: null,
        projectID: null,
        employeeID: null,
        hoursWorked: null,
        taskDescription: null,
      },
      status: [
        {
          1: "Approved",
        },
        {
          1: "light-success",
        },
      ],
      filteredTimesheet: [],
    };
  },
  computed: {
    ...mapGetters("timesheetModule", {
      timesheet: "timesheet",
      timesheetId: "timesheetId",
      loading: "loading",
    }),
    ...mapGetters("projectModule", {
      projects: "projects",
      tasks: "tasks",
      loading: "loading",
    }),
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
  },
  methods: {
    ...mapActions("timesheetModule", [
      "addTimesheetAction",
      "getTimesheetListAction",
      "getTimesheetIdAction",
      "removeTimesheetAction",
      "updateTimesheetAction",
    ]),
    ...mapActions("projectModule", [
      "getProjectListAction",
      "removeProjectAction",
      "getProjectAssigneesAction",
      "getProjectTasksAction",
    ]),
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    formatMonth(date) {
      const options = { month: "long" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    getEmployee(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      return employee ? employee.firstName + "" + employee.lastName : "-";
    },
    getStatusVariant(status) {
      switch (status) {
        case "PENDING":
          return "light-info";
        case "APPROVE":
          return "light-warning";
        case "REJECT":
          return "light-danger";
        case "DONE":
          return "light-success";
        default:
          return "secondary";
      }
    },
    viewTimesheet(item){
this.timesheetId = { ...item };
this.$refs.modalviewTimesheet.show();
    },
    // async viewTimesheet(id) {
    //   try {
    //     this.$swal({
    //       title: "Loading...",
    //       text: "Please wait while the details are loading...",
    //       allowEscapeKey: false,
    //       allowOutsideClick: false,
    //       didOpen: () => {
    //         this.$swal.showLoading();
    //       },
    //     });
    //     await this.getTimesheetIdAction(id); // Fetch the timesheet data by ID
    //     this.$swal.close();
    //     this.$bvModal.show("modal-view-approved-timesheet");
    //   } catch (error) {
    //     console.error("Failed to load timesheet data:", error);
    //   }
    // },
    async fetchTimesheetData() {
      this.mainLoading = true;
      try {
        this.$swal({
          title: "Loading...",
          text: "Please wait while the details are loading...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        await this.getTimesheetListAction().then(() => {
          this.filteredTimesheet = this.timesheet.filter(
            (timesheet) => timesheet.status === "REJECTED"
          );
          this.totalRows = this.filteredTimesheet.length;
        });
        await this.getEmployeeListAction().then(() => {
          this.employeeOptions = this.employeeList.map((employee) => ({
            value: employee.id,
            text: `${employee.firstName} ${employee.lastName}`,
          }));
        });

        await this.getProjectListAction().then(() => {
          this.projectOptions = this.projects.map((project) => ({
            value: project.projectId,
            text: `${project.name}`,
          }));
        });
        this.$swal.close();
      } catch (error) {
      } finally {
        this.mainLoading = false;
      }
    },
  },
  async mounted() {
    await this.fetchTimesheetData();
  },
};
</script>
